<p [hidden]="true">Network Detector Component ...</p>